import React from 'react';
import { ListGroup } from 'react-bootstrap';

const ListView = ({ 
    children, 
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    variant, 
    horizontal, 
    numbered = false, 
    style, 
    className,
    ...props 
}) => {
    return (
        <ListGroup 
            variant={variant} 
            horizontal={horizontal} 
            numbered={numbered} 
            className={className} 
            style={style}
            {...props}
        >
            {children}
        </ListGroup>
    );
};

export default ListView;
